import {
    convertUniversalDateTimeToPersianDateTime, RaikoAlert, raikoAlertTypes,
    RaikoBaseCardContainer,
    RaikoCreatorInfo,
    RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoGridTwoColumn, RaikoHtmlTextEditor, RaikoImageCropper,
    RaikoLabel,
    RaikoLabelType, RaikoMagazineThumbnailUpload,
    RaikoMobileInputOutlined,
    RaikoNumberInputOutlined,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined,
    RaikoSimpleMultiLineInputOutlined, RaikoToggleOutlined,
    showServerErrorMessage, showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {useParams} from "react-router-dom";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import React, {useEffect, useState} from "react";
import LanguageSelector from "../../../component/languageSelector/LanguageSelector";
import {TourismService} from "../../../serverService/tourism/TourismService";
import {LanguageHelper} from "../../../util/LanguageHelper";
import RaikoLeafletMap from "../../../raikoComponents/raikoLeafletMap/RaikoLeafletMap";
import {RaikoLeafletIranProvinces} from "../../../raikoComponents/raikoLeafletMap/RaikoLeafletIranProvinces";
import RaikoBaseDialogContentContainer
    from "../../../raikoComponents/raikoBaseDialogContentContainer/RaikoBaseDialogContentContainer";
import RaikoTextEditor from "../../../raikoComponents/raikoTextEditor/RaikoTextEditor";
import RaikoCustomBlogEditorTextEditor
    from "../../../raikoComponents/raikoCustomBlogEditor/RaikoCustomBlogEditorTextEditor";

export default function TourismPlaceDetailBasicInfo() {

    const {id: placeId} = useParams()

    const service = new TourismService();
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [languageId, setLanguageId] = useState(LanguageHelper.getLanguageCode);

    const [title, setTitle] = useState("");
    const [hours, setHours] = useState("");
    const [address, setAddress] = useState("");
    const [description, setDescription] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [published, setPublished] = useState(false);

    const [createdAt, setCreatedAt] = useState("");
    const [createdBy, setCreatedBy] = useState("");

    const [formLoading, setFormLoading] = useState(false);
    const [publishStateLoading, setPublishStateLoading] = useState(false);
    const [locationLoading, setLocationLoading] = useState(false)

    const [latPoint, setLatPoint] = useState()
    const [lngPoint, setLngPoint] = useState()

    const [thumbnailFile, setThumbnailFile] = useState()
    const [thumbnailImage, setThumbnailImage] = useState()

    const [thumbnailLoading, setThumbnailLoading] = useState(false)


    useEffect(() => {
        if (typeof languageId !== "undefined" && typeof service !== "undefined") {
            getDataFromServer()
            getGeoInfo()
            getThumbnail()
        }
    }, []);

    function getDataFromServer() {
        loading.show();
        service.getTourismPlaceDetail(languageId, placeId)
            .then(response => {
                setTitle(response.metaData ? response.metaData.title : "");
                setHours(response.metaData && response.metaData.hours ? response.metaData.hours : "")
                setAddress(response.metaData && response.metaData.address ? response.metaData.address : "")
                setDescription(response.metaData && response.metaData.description ? response.metaData.description : "")
                setPhoneNumber(response.phoneNumber)
                setPublished(response.published)
                setCreatedAt(convertUniversalDateTimeToPersianDateTime(response.createdAt))
                setCreatedBy(response.createdBy)
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide();
        })
    }


    function getGeoInfo() {
        setLocationLoading(true)
        service.getTourismPlaceMapAddress(placeId)
            .then(response => {
                if (response.latitude) {
                    setLatPoint(response.latitude)
                    setLngPoint(response.longitude)
                }
            })
            .catch(reason => {
                showServerErrorMessage(reason)
            })
            .finally(_ => {
                setLocationLoading(false)
            })
    }

    function getThumbnail() {
        setThumbnailLoading(true)
        service.getTourismPlaceThumbnail(placeId)
            .then(response => {
                setThumbnailImage(response.downloadUrl)
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setThumbnailLoading(false)
        })
    }

    function handleUpdateInfo() {
        if (description && description.length > 0) {
            setFormLoading(true)
            service.updateTourismPlaceGlobalInfo(
                placeId,
                languageId,
                phoneNumber,
                title,
                hours,
                address,
                description
            ).then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
                showServerErrorMessage(reason)
            }).finally(_ => {
                setFormLoading(false)
            })
        } else {
            showWarningMessage("لطفا توضیحات مکان را وارد نمایید")
        }
    }

    function handleChangePublishState() {
        setPublishStateLoading(true)
        service.changeTourismPublishState(
            placeId,
            published
        ).then(response => {
            if (published)
                showSuccessMessage("انتشار مطلب با موفقیت انجام شد.")
            else
                showWarningMessage("وضعیت انتشار به پیش نویس تغییر پیدا کرد.")
        }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setPublishStateLoading(false)
        })
    }

    function handleUpdateGeoInfo() {
        if (latPoint && lngPoint !== undefined) {
            setLocationLoading(true)
            service.updateTourismPlaceLocation(
                placeId,
                latPoint,
                lngPoint
            ).then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
                showServerErrorMessage(reason)
            }).finally(_ => {
                setLocationLoading(false)
            })
        }
    }

    function handleChoosImage(file, preview) {
        setThumbnailImage(preview)
        setThumbnailFile(file)
    }

    function handleUpdateThumbnail() {
        if (thumbnailFile) {
            setThumbnailLoading(true)
            service.updateTourismPlaceThumbnail(
                placeId,
                thumbnailFile
            ).then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
                showServerErrorMessage(reason)
            }).finally(_ => {
                setThumbnailLoading(false)
            })
        } else {
            showWarningMessage("لطفا ابتدا تصویر مورد نظر را انتخاب نمایید.")
        }
    }

    return (
        <RaikoGridOneColumn className={css`gap: 1.5rem`}>


            <LanguageSelector
                languageId={languageId}
                setLanguageId={setLanguageId}
                handleGetInfo={getDataFromServer}
            />

            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"اطلاعات پایه"}
                    hasActionButton
                    actionButtonOnclickWithValidation={handleUpdateInfo}
                    actionButtonLoadingState={formLoading}
                >
                    <RaikoMobileInputOutlined
                        labelText={"موبایل"}
                        value={phoneNumber}
                        setValue={setPhoneNumber}
                        required
                    />
                    <RaikoLabel text={"قابل ترجمه"} raikoLabelType={RaikoLabelType.TITLE}/>
                    <RaikoGridTwoColumn>
                        <RaikoSimpleInputOutlined labelText={"نام مکان"} value={title} setValue={setTitle}
                                                  required={true}/>
                        <RaikoSimpleInputOutlined labelText={"ساعت کاری"} value={hours} setValue={setHours}
                                                  required={true}/>
                    </RaikoGridTwoColumn>
                    <RaikoSimpleMultiLineInputOutlined labelText={"نشانی"} value={address} setValue={setAddress}
                                                       required={true}/>
                    <RaikoLabel text={"متن توضیحات"}/>
                    {/*<RaikoSimpleMultiLineInputOutlined labelText={"متن توضیحات"} value={description} setValue={setDescription}*/}
                    {/*                                   required={true}/>*/}
                    {/*<RaikoHtmlTextEditor text={description} setText={_=>{}}/>*/}
<div className={css`overflow-x: hidden !important`}>
    <RaikoTextEditor text={description} setText={setDescription} />
</div>



                </RaikoSectionContainer>
            </RaikoBaseCardContainer>

            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"تصویر شاخص"}
                    subTitle={"تصویر شاخص نمایش داده شده برای کاربران"}
                    hasActionButton
                    actionButtonOnclick={handleUpdateThumbnail}
                    actionButtonLoadingState={thumbnailLoading}
                >
                    <RaikoMagazineThumbnailUpload
                        avatarFile={thumbnailImage}
                        updateAvatar={handleChoosImage}
                        loading={thumbnailLoading}
                        ASPECT_RATIO={2 / 2}
                    />
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>

            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"موقعیت مکانی"}
                    subTitle={"بر روی مکان مورد نظر در نقشه کلیک کرده و بروزرسانی نمایید."}
                    hasActionButton
                    actionButtonLoadingState={locationLoading}
                    actionButtonOnclick={handleUpdateGeoInfo}
                >
                    <RaikoLeafletMap
                        setLngPoint={setLngPoint}
                        setLatPoint={setLatPoint}
                        lngPoint={lngPoint}
                        latPoint={latPoint}
                        centerLocation={RaikoLeafletIranProvinces.Kerman}
                    />
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>

            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"وضعیت انتشار"}
                    subTitle={"تغییر وضعیت انتشار برای مشاهده ی مکان توسط کاربران"}
                    hasHelperButton
                    helperTitle={"وضعیت انتشار"}
                    helperContent={
                        <RaikoBaseDialogContentContainer>
                            <RaikoLabel
                                text={"مکان در ابتدا به صورت پیش نویس قرار خواهد گرفت و فقط توسط ادمین در پنل مدیریت قابل مشاهده و ویرایش خواهد بود."}/>
                            <RaikoLabel
                                text={"برای مشاهده ی مطلب توسط کاربران می بایست وضعیت انتشار را از روی پیش نویس به منتشر شده تغییر دهید."}/>
                            <RaikoLabel
                                text={"⚠️قبل از انتشار مکان حتما از صحت اطلاعات و تکمیل بودن همه ی قسمت ها اطمینان حاصل نمایید!"}/>
                        </RaikoBaseDialogContentContainer>
                    }

                    hasActionButton
                    actionButtonLoadingState={publishStateLoading}
                    actionButtonOnclick={handleChangePublishState}
                >
                    <RaikoGridOneColumn>
                        <RaikoToggleOutlined
                            checked={published}
                            setChecked={setPublished}
                            labelText={"منتشر شده /  پیش نویس"}
                        />
                    </RaikoGridOneColumn>
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>

            <RaikoCreatorInfo
                createdBy={createdBy}
                createdAt={createdAt}
            />
        </RaikoGridOneColumn>
    )
}